/**
 * A short name for a paired display, from what it reported when it registered (its user agent). The NoorView TV app
 * adds "NoorViewTV/<version> (<model>)"; a web browser gets a rough description.
 */
export function deviceLabel(userAgent: string | null | undefined): string | null {
  if (!userAgent) return null;
  const app = /NoorViewTV\/[\w.]+ \(([^)]+)\)/.exec(userAgent);
  if (app) return app[1]!.trim();
  const os = /Windows/.test(userAgent) ? 'Windows' : /Mac OS X|Macintosh/.test(userAgent) ? 'Mac' : /CrOS/.test(userAgent) ? 'Chromebook'
    : /Android/.test(userAgent) ? 'Android' : /iPhone|iPad/.test(userAgent) ? 'iPhone or iPad' : /Linux/.test(userAgent) ? 'Linux' : '';
  const browser = /Edg\//.test(userAgent) ? 'Edge' : /Firefox\//.test(userAgent) ? 'Firefox' : /Chrome\//.test(userAgent) ? 'Chrome' : /Safari\//.test(userAgent) ? 'Safari' : 'Web browser';
  return os ? `${browser} on ${os}` : browser;
}
